import axios from "axios";

export const UPLOAD_CLOUDINARY = (data: any) => {
  return axios.post(
    `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
    data
  );
};
